import { TonWalletUtils } from "@lib/secrets"
import { useEffect, useState } from "react"

const useRecoveryPhrase = () => {
    const [recoveryPhrase, setRecoveryPhrase] = useState('')
    
    useEffect(() => {
        async function getRecoveryPhrase() {
            const phrase = await TonWalletUtils.getMnemonic()
            if (!phrase) return
            setRecoveryPhrase(phrase)
        }
        getRecoveryPhrase()
    }, [])

    return recoveryPhrase
}

export default useRecoveryPhrase
